import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 15000 });

const getPasscode = () => sessionStorage.getItem('wwm_admin_passcode') || '';
const adminHeaders = () => ({ 'X-Admin-Passcode': getPasscode() });

export const api = {
  listSessions: (type) => http.get('/sessions', { params: type ? { type } : {} }).then(r => r.data),
  getSession: (id) => http.get(`/sessions/${id}`).then(r => r.data),
  playSession: (id) => http.post(`/sessions/${id}/play`).then(r => r.data),

  listFeedback: () => http.get('/feedback').then(r => r.data),
  createFeedback: (payload) => http.post('/feedback', payload).then(r => r.data),
  updateFeedback: (id, payload) => http.put(`/feedback/${id}`, payload, { headers: adminHeaders() }).then(r => r.data),
  deleteFeedback: (id) => http.delete(`/feedback/${id}`, { headers: adminHeaders() }).then(r => r.data),

  verifyAdmin: (passcode) => http.post('/admin/verify', {}, { headers: { 'X-Admin-Passcode': passcode } }).then(r => r.data),
  changePasscode: (currentPasscode, newPasscode) => http.post('/admin/change-passcode', { currentPasscode, newPasscode }, { headers: adminHeaders() }).then(r => r.data),
  getSecurityKeyStatus: () => http.get('/admin/security-key/status', { headers: adminHeaders() }).then(r => r.data),
  setSecurityKey: (newSecurityKey, confirmSecurityKey) => http.post('/admin/security-key', { newSecurityKey, confirmSecurityKey }, { headers: adminHeaders() }).then(r => r.data),
  resetPasscode: (securityKey, newPasscode) => http.post('/admin/reset-passcode', { securityKey, newPasscode }).then(r => r.data),

  // Blogs
  listBlogs: (params) => http.get('/blogs', { params: params || {} }).then(r => r.data),
  listBlogCategories: () => http.get('/blogs/meta/categories').then(r => r.data),
  getBlog: (slugOrId) => http.get(`/blogs/${slugOrId}`).then(r => r.data),
  adminListBlogs: () => http.get('/admin/blogs', { headers: adminHeaders() }).then(r => r.data),
  createBlog: (payload) => http.post('/blogs', payload, { headers: adminHeaders() }).then(r => r.data),
  updateBlog: (id, payload) => http.put(`/blogs/${id}`, payload, { headers: adminHeaders() }).then(r => r.data),
  deleteBlog: (id) => http.delete(`/blogs/${id}`, { headers: adminHeaders() }).then(r => r.data),
  adminFeedback: () => http.get('/admin/feedback', { headers: adminHeaders() }).then(r => r.data),
  createSession: (payload) => http.post('/sessions', payload, { headers: adminHeaders() }).then(r => r.data),
  updateSession: (id, payload) => http.put(`/sessions/${id}`, payload, { headers: adminHeaders() }).then(r => r.data),
  deleteSession: (id) => http.delete(`/sessions/${id}`, { headers: adminHeaders() }).then(r => r.data),
};

export default api;
